/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 18.07.2016.
 */

import React, {Component, PropTypes} from 'react';
import {VelocityTransitionGroup} from 'velocity-react';

import Translate from '../../Translate';

class CommonMessage extends Component {
  constructor(props) {
    super(props);

    this.animationEnter = {
      translateY: '0px',
      opacity: 1
    };
    this.animationLeave = {
      translateY: '100px',
      opacity: 0
    };

    this.state = {
      isShown: false,
      toClose: false
    };
  }

  componentDidMount() {
    this.setState({
      isShown: this.props.isShown
    });
  }

  componentWillReceiveProps(newProps) {

    this.setState({
      isShown: newProps.isShown
    });
  }

  _onAction(action) {

    if (action) action();

    this._onCrossClick();
  }

  _onAnimationComplete() {

    if (this.state.toClose) this.props.onClose();
  }

  _onCrossClick() {

    this.setState({
      isShown: false,
      toClose: true
    });

    this.props.onClose();
  }

  _renderAction() {

    return this.props.message.actions.map((action, index) => {

      return <a key={'action_' + index} className="btn-dark-popup pointer" onClick={this._onAction.bind(this, action.func)}> <Translate content={action.title} /> </a>;
    });
  }

  render() {

    return (
      <div>
        {this.state.isShown && <a className="mw-close ico ico-close pointer slider-resume" href="javascript:void(0)" onClick={this._onCrossClick.bind(this)}></a>}
        {this.state.isShown && <div>
          <div className="popup-block common">
            <VelocityTransitionGroup
              enter={{animation: this.animationEnter, easing: 'ease-in-out', duration: 350}}
              leave={{animation: this.animationLeave, easing: 'ease-in-out', duration: 150, complete: this._onAnimationComplete.bind(this)}}>
              {this.state.isShown ? <div>
                <strong> {this.props.message.title || ''} </strong>
                <div className="mt">
                  <em> {this.props.message.body || ''} </em>
                </div>
                <div className="mt+ message-actions">
                  {this.props.message.actions && this.props.message.actions.length && this._renderAction()}
                </div>
              </div> : undefined }
            </VelocityTransitionGroup>
          </div>
        </div>}
      </div>
    );
  }
}

CommonMessage.propTypes = {
  message: PropTypes.shape({
    type: PropTypes.string.isRequired,
    title: PropTypes.string,
    body: PropTypes.string,
    actions: PropTypes.arrayOf(PropTypes.shape({
      title: PropTypes.string.isRequired,
      func: PropTypes.func.isRequired
    }))
  }),
  onClose: PropTypes.func.isRequired,
  isShown: PropTypes.bool.isRequired
};

export default CommonMessage;



// WEBPACK FOOTER //
// ./src/components/ModalWindow/Common/common-message.js